import React from 'react';
import { render } from 'react-dom';
import {Router} from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './_helpers';
import { history } from './_helpers'
import routes from './routes';
//import App from './App';

// import main style dependency file
import './index.css';
import 'react-widgets/lib/scss/react-widgets.scss';

// import 'react-table/react-table.css'

render(
    <Provider store={store}>
        <Router history={history}>
            {routes}     
        </Router>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js